<script>
import { mobileProduct } from '@site/data/homeContent'
import AppIcon from '@site/components/common/AppIcon.vue'

export default {
  name: 'MobileSection',
  components: { AppIcon },
  data() {
    return { mobileProduct }
  },
}
</script>

<template>
  <section class="section section--light" id="mobile">
    <div class="container">
      <div class="section-head reveal">
        <span class="section-eyebrow">随时随地管店</span>
        <h2>掌上管店 + 专属小程序，生意不停歇</h2>
        <p>端上管理、微信私域生意，让门店 24 小时不打烊</p>
      </div>

      <div class="grid grid--2">
        <div v-for="(block, key) in mobileProduct" :key="key" class="card mobile-card reveal">
          <div class="mobile-card__head">
            <div class="icon-badge"><AppIcon :name="key === 'app' ? 'mobile' : 'monitor'" /></div>
            <h3>{{ block.title }}</h3>
          </div>
          <ul class="mobile-card__list">
            <li v-for="item in block.items" :key="item">
              <span class="mobile-card__tick"><AppIcon name="check" :size="14" /></span>
              <span>{{ item }}</span>
            </li>
          </ul>
          <div class="mobile-card__mockup">
            <div class="mobile-card__mockup-bar"></div>
            <span>{{ block.title }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<style lang="scss" scoped>
.mobile-card {
  &__head {
    display: flex;
    align-items: center;
    gap: 14px;
    margin-bottom: 22px;

    h3 { font-size: $font-card; font-weight: $weight-bold; }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin-bottom: 26px;

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      color: $color-text;
      font-size: 15px;
    }
  }

  &__tick {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: linear-gradient(135deg, $color-primary, $color-secondary);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  &__mockup {
    background: $gradient-dark;
    border-radius: $radius-md;
    padding: 18px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 14px;
    text-align: center;

    &-bar { height: 6px; width: 40%; background: rgba(255,255,255,0.28); border-radius: 3px; margin: 0 auto 10px; }
  }
}
</style>



// WEBPACK FOOTER //
// src/site/components/home/MobileSection.vue